"use strict";

document.addEventListener('DOMContentLoaded', function() {
    var subscribeForms = $('.investor-info-subscription-block');

    if (subscribeForms.length > 0) {
        subscribe.initialize();
    }
});

var subscribe = {
    initialize: function () {
        var self = this;
        var hasErrors = false;
        var languages = $('[data-languages] input[type="checkbox"]');
        var languagesErrorMsg = $('.languages.validation-error');
        var informationTypes = $('[data-information-types] input[type="checkbox"]');
        var informationTypesErrorMsg = $('.information-types.validation-error');
        var requiredFields = $('.cision-form input[type="text"][aria-required="true"]');

        $('[data-languages] input[type="checkbox"]').on('change', function () {
            if ($(this).prop('checked') === true) {
                self.handleValidation(true, languagesErrorMsg);
            }
        });
        $('[data-information-types] input[type="checkbox"]').on('change', function () {
            if ($(this).prop('checked') === true) {
                self.handleValidation(true, informationTypesErrorMsg);
            }
        });

        $('.cision-form').submit(function (e) {
            if (languages.length > 0) {
                var languageChecked = false;
                languages.each(function (index, elem) {
                    if ($(elem).prop('checked') === true) {
                        languages = true;
                    }
                });
                if (languages !== true) {
                    hasErrors = true;
                    self.handleValidation(false, languagesErrorMsg);
                } else {
                    self.handleValidation(true, languagesErrorMsg);
                }
            } 
            if (informationTypes.length > 0) {
                var infoTypeChecked = false;
                informationTypes.each(function (index, elem) {
                    if ($(elem).prop('checked') === true) {
                        infoTypeChecked = true;
                    }
                });
                if (infoTypeChecked !== true) {
                    hasErrors = true;
                    self.handleValidation(false, informationTypesErrorMsg);
                } else {
                    self.handleValidation(true, informationTypesErrorMsg);
                }
            }
            if (requiredFields.length > 0) {
                requiredFields.each(function (index, elem) {
                    var el = $(elem);
                    var elVal = el.val();

                    if (el.hasClass('form-control-email')) {
                        if ($.trim(elVal).length === 0 || self.validateEmail(elVal) || elVal === '') {
                            hasErrors = true;
                            self.handleValidation(false, el.next('.validation-error'));
                        }
                    } else if (elVal === '') {
                        hasErrors = true;
                        self.handleValidation(false, el.next('.validation-error'));
                    } else {
                        self.handleValidation(true, el.next('.validation-error'));
                    }
                });
            } else {
                $('.validation-error').addClass('hidden');
                $('.contact-form button').prop('disabled', true);
            }

            if (hasErrors) {
                e.preventDefault();
                hasErrors = false;
            }
        });

        $('.cision-form input[type=text]').change(function () {
            $(this).next('.validation-error').addClass('hidden');
        });
    },

    validateEmail: function (email) {
        var reg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
        if (!reg.test(email)) {
            return true;
        } else {
            return false;
        }
    },

    handleValidation: function (isValid, elem) {
        if (isValid) {
            elem.addClass('hidden');
            elem.attr('aria-hidden', 'true');
        } else {
            elem.removeClass('hidden');
            elem.attr('aria-hidden', 'false');
        }
    }
};